import { render, staticRenderFns } from "./AudioSubmission.vue?vue&type=template&id=50fe8528"
import script from "./AudioSubmission.vue?vue&type=script&lang=js"
export * from "./AudioSubmission.vue?vue&type=script&lang=js"
import style0 from "./AudioSubmission.vue?vue&type=style&index=0&id=50fe8528&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports